module.exports = __webpack_public_path__ + "static/media/md-flag.87ab61b1.svg";